<template>
  <layoutDefault>
    <!-- title -->
    <ContentTitle ref="top" title="특화서비스 통계 (2019년 9월 ~ 2020년 7월)">
      <template v-slot:subTitle>
        <router-link :to="'/stats/v2'" style="color:#ea002c;">[현재 통계 바로 가기]</router-link>
      </template>
    </ContentTitle>
    <!-- //title -->

    <ul class="section_tab">
      <li class="cell">
        <router-link to="/stats/v1/daily" exact-active-class="selected" class="item">전체통계(Daily)</router-link>
      </li>
      <li class="cell">
        <router-link to="/stats/v1/monthly" exact-active-class="selected" class="item">전체통계(Monthly)</router-link>
      </li>
      <li class="cell">
        <router-link to="/stats/v1/brain" exact-active-class="selected" class="item">두뇌톡톡 통계</router-link>
      </li>
      <li class="cell">
        <router-link to="/stats/v1/health" exact-active-class="selected" class="item">건강톡톡 통계</router-link>
      </li>
      <li class="cell">
        <router-link to="/stats/v1/target" active-class="selected" class="item">대상자별 통계</router-link>
      </li>
    </ul>

    <router-view></router-view>
  </layoutDefault>
</template>

<script>

export default {
  name: 'analytics',
}
</script>
